export default __webpack_public_path__ + "4dd2db703ccbcb5d69c5e8ab714c608f.svg";